import React from 'react';
import { Skeleton, Paper, Table, TableHead, TableBody, TableRow, TableCell, TableContainer } from '@mui/material';
import { COLUMNS } from './reportingHelpers';

export default function ReportingTableSkeleton() {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {COLUMNS.map((col, i) => (
              <TableCell key={i} sx={{ backgroundColor: '#213067', color: 'white', fontWeight: 'bold' }}>
                {col.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: 10 }).map((_, i) => (
            <TableRow key={i}>
              {COLUMNS.map((col, j) => (
                <TableCell key={j}>
                  <Skeleton variant="text" />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
